import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { goPreviousFormAsync } from 'redux/actions/contractWizardActions';
import { AppState } from '../../types/redux';
import NavigationBar from './NavigationBar';

const mapStateToProps = (state: AppState) => ({
	isLoading: state.contractWizard.isLoading,
	forms: state.contractWizard.forms,
	currentForm: state.contractWizard.currentForm,
	currentStep: state.contractWizard.currentStep,
	selectedButton: state.collectedState.selectedButton,
});

/* istanbul ignore next */
const mapDispatchToProps = (
	dispatch: ThunkDispatch<Promise<any>, void, Action>
) => ({
	goPreviousForm: () => {
		dispatch(goPreviousFormAsync());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(NavigationBar);
